<template lang="html">
  <div class="center-content">
    <CenterItem title="头像">
      <template v-slot:right>
        <div class="avatar">
          <input type="file" @change="uploadFile" class="input">
          <img class="avatars" v-if="!getUsersAvatar" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png" alt="">
          <img class="avatars" v-else :src="`${getUsersAvatar}?x-oss-process=image/resize,m_fill,w_128,h_128`" alt="">
        </div>
        <img class="right" src="../../../assets/images/right.svg" alt="">
      </template>
    </CenterItem>
    <CenterItem title="昵称" @click="goRouter('editNickName')">
      <template v-slot:right>
        <span>{{ nickName }}</span>
        <img class="right" src="../../../assets/images/right.svg" alt="">
      </template>
    </CenterItem>
    <CenterItem title="性别" @click="editGender">
      <template v-slot:right>
        <span>{{ gender ? '女' : '男' }}</span>
        <img class="right" src="../../../assets/images/right.svg" alt="">
      </template>
    </CenterItem>
    <CenterItem title="个性签名" @click="goRouter('editSignName')"/>
    <button type="button"  @click="logout" class="logout">退出登录</button>
    <ModelSelect v-show="selectGender" :value="gender" @close="closeSelect" @change="selectPhone"/>
    <Tip v-if="message" @closeModel="closeModel" :label="label"/>
  </div>
</template>

<script>
import { put, putFile } from '../../../utils/request'
import { get, set, clear } from '../../../utils/token'
import { createNamespacedHelpers } from 'vuex'
import ModelSelect from '../../../components/modelSelect.vue'
import Tip from '../../../components/message.vue'
import CenterItem from '../../../components/centerItem'
const { mapGetters, mapActions } = createNamespacedHelpers('user')
const { mapActions: mapTabBarActions } = createNamespacedHelpers('tabbar')
export default {
  components: {
    Tip,
    ModelSelect,
    CenterItem
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.updateTabIndex('center')
    })
  },
  data () {
    return {
      nickName: '请补充昵称',
      avatar: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/user/defaultProfile.png',
      password: '',
      signName: '',
      gender: 1,
      selectGender: false,
      genders: [
        {
          value: 0,
          label: '男'
        },
        {
          value: 1,
          label: '女'
        },
        {
          value: 3,
          label: '保密'
        }
      ],
      message: false,
      label: ''
    }
  },
  mounted () {
    const user = get('user')
    this.nickName = user ? user.nickName : ''
    this.avatar = user ? user.avatar : ''
    this.password = user ? user.password : ''
    this.signName = user ? user.signName : ''
    this.gender = user ? user.gender : 1
  },
  methods: {
    editGender () {
      this.selectGender = true
    },
    selectPhone (value) {
      this.gender = value
      this.selectGender = false
      this.editUser()
    },
    closeSelect () {
      this.selectGender = false
    },
    closeModel () {
      this.message = false
    },
    ...mapActions({
      updateUserAvater: 'updateUserAvater',
      updateUserGender: 'updateUserGender'
    }),
    ...mapTabBarActions({
      updateTabIndex: 'updateTabIndex'
    }),
    ...mapGetters({
      getUser: 'getUser'
    }),
    goRouter (path) {
      this.$router.push(`/exerland/${path}`)
    },
    logout () {
      const user = this.getUser() || get('user')
      if (user && user.nickName) {
        clear('user')
      }
      this.$router.push('/exerland/login')
    },
    test () {
      const user = get('user')
      user.hobby = ''
      user.nickName = ''
      user.isAgree = false
      set('user', user)
    },
    uploadFile (e) {
      const promise = putFile({
        url: '/bbs/uploadFile',
        file: e.target.files[0]
      })
      promise.then(res => {
        const { status, data: { data } } = res
        if (Object.is(status, 200)) {
          this.avatar = data[0]
          this.editUser()
        }
      })
    },
    editUser (value) {
      const user = this.getUser() && this.getUser().id ? this.getUser() : get('user')
      const promise = put({
        url: `/user/updateUserInfo/${user ? user.id : ''}`,
        data: {
          gender: this.gender,
          avatar: this.avatar
        }
      })
      promise.then(res => {
        const { data: { message, detail } } = res
        if (Object.is(message, '用户信息更新完成')) {
          // this.message = true
          // this.label = message
          if (user) {
            Object.assign(user, detail)
            user.gender = this.gender
            user.avatar = this.avatar
          }
          set('user', user)
          this.updateUserGender(user.gender)
          this.updateUserAvater(this.avatar)
        } else {
          this.message = true
          this.label = message
        }
      })
    }
  },
  computed: {
    getUsersAvatar () {
      return this.avatar || (this.getUser() && this.getUser().avatar)
    },
    getUsersNickName () {
      return this.nickName || (this.getUser() && this.getUser().nickName)
    },
    getUsersSignName () {
      return this.signName || (this.getUser() && this.getUser().signName)
    }
  }
}
</script>

<style lang="scss" scoped>
.center-content {
  background: #F2F2F7;
  height: calc(100vh - 50px);
  .avatar {
        display: flex;
        width:64px;
        height:64px;
        border-radius: 50%;
        margin-right: 12px;
        position: relative;
        input {
          position: absolute;
          top: 0;
          left: 0;
          width: 64px !important;
          height: 64px!important;
          border-radius: 50px;
          z-index: 9;
          padding-left: 0;
          opacity: 0;
          cursor: pointer;
        }
        .avatars {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          width: 64px;
          height: 64px;
          border-radius: 50%;
          z-index: 1;
        }
      }
      span {
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(60,60,67,0.6);
        line-height:22px;
        display: inline-block;
        margin-right: 12px;
      }
  .logout {
    border: none;
    font-size:17px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:22px;
    height:58px;
    width: 100%;
    background:rgba(255,255,255,1);
    text-align: center;
    cursor: pointer;
    margin-top: 14px;
  }
}

</style>
